

import { Options } from 'rrule';
export interface RecurringEvent {
  id?: string | number;
  title: string;
  titleToDisplay: string;
  color: any;
  start?: Date;
  end?: Date;
  rrule?: Options;
  icon?: string;
}

export interface ActivityType {
  id: string;
  text: string;
  icon: string;
}

export interface MoreEventStyles {
  top: string;
  left: string;
}

export interface ViewPeriod {
  start: Date;
  end: Date;
  events: CalendarEvent[];
}

export interface EventColor {
  primary: string;
  secondary: string;
}

export interface EventAction {
  id?: string | number;
  label: string;
  cssClass?: string;
  a11yLabel?: string;
  onClick({
    event,
    sourceEvent,
  }: {
    event: CalendarEvent;
    sourceEvent: MouseEvent | KeyboardEvent;
  }): any;
}

export interface CalendarEvent<MetaType = any> {
  id?: string | number;
  start?: Date;
  end?: Date;
  title: string;
  color?: EventColor;
  actions?: EventAction[];
  allDay?: boolean;
  cssClass?: string;
  resizable?: {
    beforeStart?: boolean;
    afterEnd?: boolean;
  };
  draggable?: boolean;
  meta?: MetaType;
  description?: string;
  rrule?: Options;
  descriptionWithHtml?: string;
  isRecur?: boolean;
  icon?: string;
}

export const colors: any = {
  'bg-color-blue': {
    primary: '#A5CDEB',
    secondary: '#004377',
  },
  'bg-color-green': {
    primary: '#FAF9F8',
    secondary: '#02494C',
  },
  'bg-color-aqua': {
    primary: '#A5D1D1',
    secondary: '02494C',
  },
  'bg-color-orange': {
    primary: ' #EFB8A3',
    secondary: '#7A2101',
  },
  'bg-color-Red': {
    primary: ' #E8A7AC',
    secondary: '#6E0811',
  },
  'bg-color-purple': {
    primary: '#CCBDDD',
    secondary: '#583B80',
  },
  'bg-color-fuchsia': {
    primary: ' #F2A4D3',
    secondary: '#7F004E',
  },
  'bg-color-gray': {
    primary: '#FAF9F8',
    secondary: '#3B4447',
  },
  'bg-color-navy': {
    primary: '#A5B7C6',
    secondary: '#D1E8FF',
  },
};
